import { FAIcon, IconStyle, Theme } from '@nextgen-web-framework/all';
import { InpurErrorComponentProps } from './types/propTypes';
import styles from './InputFormComponent.module.scss';

const InputErrorComponent = ({ t, touched, error, className, labelParams = null }: InpurErrorComponentProps) => {
  const label = error ? t(error, labelParams) : '';
  return (
    <>
      {touched && error ? (
        <div className={`${styles['error-form']} ${className ?? ''}`} data-testid="error-msg-test-id">
          <FAIcon iconName="square-exclamation" iconStyle={IconStyle.REGULAR} theme={Theme.ERROR} /> {label}
        </div>
      ) : (
        <div className={styles['no-error-form']} data-testid="no-error-msg-test-id"></div>
      )}
    </>
  );
};

export default InputErrorComponent;
